import { toast } from 'react-toastify'

import { ApiError, ErrorHandlerOptions } from '@/types/api.types'

const getStatusMessage = (status: number): string => {
  switch (status) {
    case 400: return 'Invalid request. Please check your input.'
    case 401: return 'Authentication required. Please log in.'
    case 403: return 'You don\'t have permission for this action.'
    case 404: return 'The requested resource was not found.'
    case 409: return 'Conflict occurred. The resource already exists.'
    case 422: return 'Validation failed. Please check your input.'
    case 429: return 'Too many requests. Please try again later.'
    case 500: return 'Internal server error. Please try again later.'
    case 502: return 'Server is temporarily unavailable.'
    case 503: return 'Service unavailable. Please try again later.'
    default:  return `Request failed with status ${status}.`
  }
}

const getErrorCodeMessage = (errorCode: string | undefined): string => {
  switch (errorCode) {
    case 'ECONNABORTED': return 'Request timeout. Please try again.'
    case 'ERR_NETWORK':  return 'Network error. Please check your connection.'
    default:             return 'Network error occurred. Please try again.'
  }
}
export const handleApiError = (error: ApiError, options: ErrorHandlerOptions = {}): string => {
    const { 
      showToast = true, 
      silent = false,
      toastType = 'error',
      customMessage,
    } = options
    
    if (silent) {
        return ''
    }

    let message = customMessage
    
    if (!message) {
      if (error.response) {
        const { status, data } = error.response

        message = data?.message || data?.error || getStatusMessage(status)
      } else if (error.request) {
        message = getErrorCodeMessage(error.code)
      } else {
        message = 'An unexpected error occurred.'
      }
    }
    
    if (showToast) {
      switch (toastType) {
        case 'error':
          toast.error(message)
          break
        case 'warning':
          toast.warning(message)
          break
        case 'info':
          toast.info(message)
          break
        default:
          toast.error(message)
      }
    }
    
    return message
}
